import {
  combineReducers,
} from 'redux';
import refundList from './reducers/refundList';
import numberOfTickets from './reducers/numberOfTickets';
import totals from './reducers/totals';
import {
  REGISTER_FETCH_SUMMARY,
  REGISTER_FETCH_SUMMARY_START,
} from './constants';
import { CAPTURE_REFUND } from '../../terminal/constants';

const isLoading = (state = false, action) => {
  switch (action.type) {
    case CAPTURE_REFUND:
    case REGISTER_FETCH_SUMMARY_START:
      return true;
    case REGISTER_FETCH_SUMMARY:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  isLoading,
  refundList,
  numberOfTickets,
  totals,
});
